import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aefb4d5a")

_pushScopeId("data-v-aefb4d5a")
const _hoisted_1 = { class: "d-flex align-items-start gap-3" }
const _hoisted_2 = { class: "flex-shrink-0 position-relative prospect-inbox-row__avatar-wrap" }
const _hoisted_3 = { class: "flex-grow-1 min-w-0" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between gap-2 mb-1" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2 flex-shrink-0" }
const _hoisted_6 = { class: "text-muted fs-8" }
const _hoisted_7 = { class: "d-flex flex-wrap align-items-center gap-2" }
const _hoisted_8 = { class: "badge badge-light fw-semibold" }
const _hoisted_9 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_10 = {
  key: 2,
  class: "badge badge-light-warning"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ContactAvatar = _resolveComponent("ContactAvatar")

  return (_openBlock(), _createBlock("button", {
    type: "button",
    class: ["prospect-inbox-row w-100 border-0 text-start px-4 py-4", {
      'prospect-inbox-row--active': _ctx.selected,
      'prospect-inbox-row--unread': _ctx.hasUnread
    }],
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select', _ctx.prospect)))
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_ContactAvatar, {
          "profile-photo": _ctx.prospect.profilePhoto,
          "display-name": _ctx.displayName
        }, null, 8, ["profile-photo", "display-name"]),
        _createVNode("div", {
          class: "symbol-badge d-flex align-items-center justify-content-center",
          style: { backgroundColor: _ctx.channel.color }
        }, [
          _createVNode("i", {
            class: [_ctx.channel.icon, "text-white fs-9"]
          }, null, 2)
        ], 4)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", {
            class: ["text-truncate", _ctx.hasUnread ? 'fw-bolder text-gray-900' : 'fw-bold text-gray-900']
          }, _toDisplayString(_ctx.displayName), 3),
          _createVNode("span", _hoisted_5, [
            (_ctx.hasUnread)
              ? (_openBlock(), _createBlock("span", {
                  key: 0,
                  class: "badge badge-circle badge-primary fw-bold prospect-inbox-row__unread-badge",
                  title: `${_ctx.unreadCount} unread`
                }, _toDisplayString(_ctx.unreadBadgeLabel), 9, ["title"]))
              : _createCommentVNode("", true),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.timeLabel), 1)
          ])
        ]),
        _createVNode("div", {
          class: ["fs-7 text-truncate mb-2", _ctx.hasUnread ? 'text-gray-800 fw-semibold' : 'text-muted']
        }, _toDisplayString(_ctx.preview), 3),
        _createVNode("div", _hoisted_7, [
          (_ctx.showChannelBadge)
            ? (_openBlock(), _createBlock("span", {
                key: 0,
                class: "badge badge-light text-gray-800 text-truncate prospect-inbox-row__channel-badge",
                title: _ctx.channelLabel
              }, _toDisplayString(_ctx.channelLabel), 9, ["title"]))
            : _createCommentVNode("", true),
          _createVNode("span", {
            class: ["badge", _ctx.gradeBadgeClass]
          }, _toDisplayString(_ctx.gradeLabel), 3),
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.prospect.leadScore ?? 0), 1),
          (_ctx.aiActive)
            ? (_openBlock(), _createBlock("span", _hoisted_9, " AI "))
            : (_openBlock(), _createBlock("span", _hoisted_10, " Manual "))
        ])
      ])
    ])
  ], 2))
})